import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

/**
 * Fallback error page shown when the long-form flow cannot continue.
 * Navigates the customer back to the site origin via `navigateHome`.
 */
@Component({
  selector: 'capq-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false,
})
export class ErrorPageComponent {
  constructor(@Inject(DOCUMENT) public document: Document) {}

  navigateHome() {
    document.location.href = document.location.origin;
  }
}
